import { gql } from '../types/generated/gql';

export const PIPELINE_CONFIG_FRAGMENT = gql(`
  fragment PipelineConfigFields on PipelineConfigInfo {
    activeSource
    altaChannelUrl
    backhaulDecoderHost
    backhaulDecoderServiceLabel
    eviProgramSwitchSrc
    eviSdpUrlAudio
    eviSdpUrlVideo
    eviSwitchDst
    fronthaulDecoderHost
    fronthaulDecoderServiceLabel
    id
    lexiInstanceUrl
    videonPrimaryStreamUrl
    videonBackupStreamUrl
    partnerLockEnabled
    partnerLockExclusions
    pd01Dst
    pd02Dst
    pd03Dst
    postGameSrc
    preGameSrc
    primaryBackhaulSrc
    primaryFronthaulSrc
    programSwitchDst
    programSwitchSrc
    sdpUrlAncillary
    sdpUrlAudio
    sdpUrlVideo
    teamId
    region
    red5PreProcStreamName
    red5PostProcStreamName
    red5PrimaryHost
    red5BackupHost
    red5PrimaryNodeGroup
    red5BackupNodeGroup
  }
`);
